export default {
  'invitationResult.title': 'Tebrikler!',
  'invitationResult.subtitle': 'Yeni kurumunuza başarıyla katıldınız!',
  'invitationResult.login': 'Giriş Yap',
};
